'use client'
import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'
import Image, { ImageLoader } from 'next/image'

import { Inscription } from '@/utils/types/inscription'
import { CDN_URL } from '@/utils/constants'
import styles from './UserIconStatic.module.css'

const myLoader: ImageLoader = ({ src }) => {
	return src
}

// a250d893917b5d611d3dfba3cc1fae73a8a23fe602bf35d4e7f3ca0c9fd3b031
const _defaultIcons = ['edd127dec980492e2057b3794c5899d6c79437af5b12ae4b96bc51a7bb384fc1']

const UserIconStatic: FC<{
	src?: string
	inscription?: Inscription
	size: number
	className?: string
	iconClassName?: string
	borderSize?: number
	defaultGradientId?: number
}> = (props): ReactElement => {
	const { size, inscription, borderSize, defaultGradientId: _defaultGradientId, className } = props
	const [fallback, setFallback] = React.useState(false)

	const imgSize = React.useMemo(() => size || 30, [size])

	const src = React.useMemo(() => {
		// const iconIndex = defaultGradientId ? defaultGradientId % 15 : 0
		const defaultIconSrc = '/default-pfp.png'

		if (props?.src) {
			return props.src
		} else if (inscription && inscription?.id) {
			return `${CDN_URL}/${inscription?.id}`
		} else {
			return defaultIconSrc
		}
	}, [props.src, inscription])

	const radius = borderSize ? imgSize + borderSize : imgSize

	return (
		<div
			className={classNames(styles.root, { [props.className ?? '']: !!className })}
			style={{
				height: `${radius}px`,
				minHeight: `${radius}px`,
				minWidth: `${radius}px`
			}}
		>
			{src && !fallback && (
				<Image
					alt="Icon"
					loader={myLoader}
					className={props.iconClassName}
					height={imgSize}
					width={imgSize}
					src={src}
					unoptimized
					priority
					onError={() => setFallback(true)}
				/>
			)}
		</div>
	)
}

export default UserIconStatic
